import { useBountyUI } from "../features";

/**
 * `hint`: one muted line under the toggle, saying what Big job does (the photo check shows it once).
 * `label`: the toggle's words, "Big job" unless given ("Project" with projectsUI, docs/projects.md).
 */
export function BigJobToggle({ checked, onChange, disabled = false, hint, label = "Big job" }: { checked: boolean; onChange: (checked: boolean) => void; disabled?: boolean; hint?: string; label?: string }) {
  const bountyUIEnabled = useBountyUI();
  if (!bountyUIEnabled) return null;
  const toggle = (
    <label class={`field toggle big-job-toggle${checked ? " on" : ""}`}>
      <input type="checkbox" checked={checked} disabled={disabled} onChange={(e) => onChange(e.currentTarget.checked)} />
      <span>{label}</span>
    </label>
  );
  if (!hint) return toggle;
  return (
    <div class="big-job-field">
      {toggle}
      <span class="muted small big-job-hint">{hint}</span>
    </div>
  );
}
